// extracted by mini-css-extract-plugin
export default {"bottomNavbar":"BottomNavbar_bottomNavbar__tObkU","notificationWrapper":"BottomNavbar_notificationWrapper__--E02","notificationBadge":"BottomNavbar_notificationBadge__frIbU"};